import { format } from 'date-fns';
import { ar } from 'date-fns/locale';
import en from 'date-fns/locale/en-US';
import es from 'date-fns/locale/es';
import fr from 'date-fns/locale/fr';
import ka from 'date-fns/locale/ka';
import { useTranslation } from 'next-i18next';
import React, { ReactNode } from 'react';

import Collapse from '@/shared/components/atoms/Collapse';

interface Props {
  date: Date | null;
  children: ReactNode;
  defaultOpen?: boolean;
}

const Day: React.FC<Props> = ({ date, children, defaultOpen }) => {
  const {
    i18n: { language },
  } = useTranslation('common');

  return (
    <Collapse
      header={
        date
          ? format(new Date(date), 'EEEE - dd MMMM yyyy ', {
              locale:
                language === 'ar'
                  ? ar
                  : language === 'es'
                  ? es
                  : language === 'fr'
                  ? fr
                  : language === 'ka'
                  ? ka
                  : en,
            })
          : ''
      }
      containerClassName=''
      childrenPadding='px-0 py-1'
      bgColor='bg-background-neutral-99'
      containerPadding='p-16'
      itemClassName='text-text-default border-xs border-neutralVariant-90'
      borderRadius='rounded-2xl'
      defaultValue={defaultOpen}
    >
      {children}
    </Collapse>
  );
};
export { Day };
